import { render, staticRenderFns } from "./SpfiView.vue?vue&type=template&id=fedd9f4e&scoped=true"
import script from "./SpfiView.vue?vue&type=script&lang=js"
export * from "./SpfiView.vue?vue&type=script&lang=js"
import style0 from "./SpfiView.vue?vue&type=style&index=0&id=fedd9f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedd9f4e",
  null
  
)

export default component.exports